function buildCustomerInteractionUrl(params) {
  const segments = [
    "performance",
    "playbooks",
    params.playbookId,
    "customer-interactions",
    params.gradingId
  ];
  const search = new URLSearchParams();
  const { target } = params;
  if (target?.tab === "assessment") {
    segments.push("assessment");
    if (target.criterionId) {
      segments.push("criteria", target.criterionId);
    }
  } else if (target?.tab === "transcript") {
    segments.push("transcript");
    if (target.quote) {
      search.set("quote", target.quote);
    }
  }
  const path = `/${segments.map(encodeURIComponent).join("/")}`;
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}
function buildCustomerPageUrl(params) {
  const segments = [
    "performance",
    "playbooks",
    params.playbookId,
    "customers",
    params.accountId
  ];
  return `/${segments.map(encodeURIComponent).join("/")}`;
}
function buildTeammatePageUrl(params) {
  const segments = [
    "performance",
    "playbooks",
    params.playbookId,
    "teammates",
    params.teammateId
  ];
  return `/${segments.map(encodeURIComponent).join("/")}`;
}
export {
  buildCustomerInteractionUrl,
  buildCustomerPageUrl,
  buildTeammatePageUrl
};
//# sourceMappingURL=customerInteractionUrl.js.map
